import type { RiskCard } from '@/entities/risk/model/riskSchema';
import type { RiskMeasure } from '@/entities/risk/model/riskSchema';
import s from './Risks.module.scss';

export function riskLevelFromScore(score: number): string {
  if (score <= 4) return 'Низкий';
  if (score <= 9) return 'Средний';
  if (score <= 16) return 'Высокий';
  return 'Критический';
}

export function parseDate(dateStr: string): Date | null {
  const m = dateStr.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  return m ? new Date(+m[3], +m[2] - 1, +m[1]) : null;
}

export function isOverdue(dateStr: string): boolean {
  const d = parseDate(dateStr);
  return d ? d.getTime() < Date.now() : false;
}

export function matrixCellClass(v: number): string {
  if (v <= 4) return s['root__matrix-cell_low'];
  if (v <= 9) return s['root__matrix-cell_med'];
  if (v <= 16) return s['root__matrix-cell_high'];
  return s['root__matrix-cell_crit'];
}

export interface RisksAnalytics {
  total: number;
  done: number;
  overdue: number;
  inProgress: number;
  reviewSoon: number;
  reviewOverdue: number;
}

export function computeRisksAnalytics(allCards: RiskCard[], allMeasures: RiskMeasure[], now: number): RisksAnalytics {
  const total = allMeasures.length;
  const done = allMeasures.filter((m) => m.status === 'ok').length;
  const overdue = allMeasures.filter((m) => isOverdue(m.deadline) && m.status !== 'ok').length;
  const inProgress = allMeasures.filter((m) => m.status === 'info').length;
  const reviewSoon = allCards.filter((c) => {
    if (!c.reviewDate) return false;
    const d = parseDate(c.reviewDate);
    if (!d) return false;
    const diff = d.getTime() - now;
    return diff > 0 && diff < 30 * 86400000;
  }).length;
  const reviewOverdue = allCards.filter((c) => c.reviewDate && isOverdue(c.reviewDate)).length;
  return { total, done, overdue, inProgress, reviewSoon, reviewOverdue };
}
